import {
  Container,
  Heading,
  Image,
  Paragraph,
  Section,
  Texts,
  Title,
} from "./style";
import QrCode from "../../assets/imgs/QR CODE PIX.png";

function Doacao() {
  return (
    <Container>
      <Texts>
        <Title>Faça parte dessa história você também</Title>
        <Paragraph>
          Sua doação transforma vidas! Contamos com sua doação para manutenção e
          ampliação de todas as atividades realizadas no Circuito Inclusão!
          Vamos juntos em prol de muitos, promovendo cada vez mais a inclusão!
          Está esperando o que para fazer o bem hoje?
        </Paragraph>
        <Paragraph>
          Sugerimos doações no valor de <span>R$10, R$25, R$50</span> ou{" "}
          <span>R$100</span> mas qualquer valor é muito bem vindo!
        </Paragraph>
        <Title>Para depósitos ou transferências</Title>
        <Heading>Instituição: 403 - cora SCD</Heading>
        <ul>
          <li>Agência: 0001</li>
          <li>Conta: 1228114-5</li>
          <li>Nome da Empresa: Associação Circuito Inclusão</li>
          <li>CNPJ: 40.821.523/0001-13</li>
        </ul>
      </Texts>

      <Section>
        <Image>
          <img src={QrCode} alt="" />
        </Image>
        <Paragraph>
          Para doar utilizando Pix, siga as orientações abaixo:
        </Paragraph>
        <ul>
          <li>abra a área PIX/QR code no app do seu banco;</li>
          <li>aponte a câmera do seu celular para o QR code a esquerda;</li>
          <li>escolha o valor que deseja doar; confirme a transação.</li>
        </ul>
      </Section>
    </Container>
  );
}
export default Doacao;
